<template>
  <div class="strategic-items-chart">
    <div class="filters">
      <select
        v-model="selectedState"
        class="filter-select"
      >
        <option value="">
          Todos os Estados
        </option>
        <option
          v-for="state in estados"
          :key="state"
          :value="state"
        >
          {{ state }}
        </option>
      </select>

      <input
        v-model="startDate"
        type="month"
        class="filter-select"
      >
      <input
        v-model="endDate"
        type="month"
        class="filter-select"
      >
    </div>

    <div class="chart-box">
      <bar-chart
        :chart-data="chartData"
        :options="chartOptions"
      />
    </div>
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs'
import { reactiveProp } from 'vue-chartjs/es/mixins'
import fetchReportData from '@/syslic/dashboard/reportService'
import filterStrategicItems from '@/syslic/dashboard/items/filterStrategicItems'

export default {
  name: 'StrategicItemsChart',
  components: {
    barChart: {
      extends: Bar,
      mixins: [reactiveProp],
      props: ['chartData', 'options'],
      mounted() {
        this.renderChart(this.chartData, this.options)
      },
      watch: {
        chartData(newData) {
          this.renderChart(newData, this.options)
        },
      },
    },
  },
  data() {
    return {
      rawData: [],
      estados: [],
      selectedState: '',
      startDate: '',
      endDate: '',
      chartData: {
        labels: [],
        datasets: [],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{ stacked: true }],
          yAxes: [{ stacked: true }],
        },
        tooltips: { mode: 'index', intersect: false },
        legend: { position: 'top' },
      },
    }
  },
  watch: {
    selectedState() {
      this.loadData()
    },
    startDate() {
      this.loadData()
    },
    endDate() {
      this.loadData()
    },
  },
  async mounted() {
    await this.loadData()
  },
  methods: {
    async loadData() {
      this.rawData = await fetchReportData(this)
      const estadosUnicos = [...new Set(this.rawData.map(item => item.stateName).filter(Boolean))]
      estadosUnicos.sort()
      this.estados = estadosUnicos
      this.updateChart()
    },
    updateChart() {
      const filteredData = filterStrategicItems(this.rawData, {
        estadoSelecionado: this.selectedState,
        startDate: this.startDate,
        endDate: this.endDate, // Agora o filtro de data está completo
      })

      const labels = filteredData.topLicitacoes.map(p => p.name)

      this.chartData = {
        labels,
        datasets: [
          {
            label: 'Número de Licitações',
            backgroundColor: '#42A5F5',
            data: filteredData.topLicitacoes.map(p => p.licitacoes),
          },
          {
            label: 'Taxa de Conversão (%)',
            backgroundColor: '#FFA726',
            data: filteredData.topConversao.map(p => p.taxaConversao),
          },
          {
            label: 'Valor Total de Venda (R$)',
            backgroundColor: '#66BB6A',
            data: filteredData.topValorVenda.map(p => p.valorVenda),
          },
        ],
      }
    },
  },
}
</script>

<style scoped>
.filters {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
}

.filter-select {
  padding: 0.5rem;
  font-size: 1rem;
  border-radius: 0.25rem;
  border: 1px solid #ccc;
  max-width: 250px;
  width: 100%;
}

.chart-box {
  width: 100%;
  height: 500px;
}
</style>
